import css from './index.module.scss';
import Folder from './Folder';
import FAQ from './FAQ';
import Tutorial from './Tutorial';
import Manuals from './Manuals';
import QuoteForm from './QuoteForm';
import { useGlobal } from '@/utils/useGlobal';
import { forwardRef, useEffect, useImperativeHandle } from 'react';

export default forwardRef(({ supportActive = '', supportData, theme, hasForm, spuId }: any, ref) => {
    const { useState, useRouter } = useGlobal();
    const { query } = useRouter();
    const [active, setActive] = useState('faq');
    const handleChangeFolder = (v: string) => {
        active !== v && setActive(v);
    };

    useEffect(() => {
        const hasActive = ['faq', 'manuals', 'form', 'tutorial'].includes(query?.active);
        const defaultActive = supportData?.faqList?.length > 0 ? 'faq' : supportData?.videoList?.length > 0 ? 'tutorial' : 'manuals';
        setActive(supportActive || (hasActive ? query?.active : defaultActive));
    }, [supportActive, query?.active]);

    useImperativeHandle(ref, () => ({
        handleChangeFolder: () => {
            handleChangeFolder('manuals');
        },
    }));

    return (
        <section className={`product-support ${css['product-support']} ${theme}`} key={spuId}>
            <Folder supportData={supportData} active={active} hasForm={hasForm} callFolder={handleChangeFolder} theme={theme} />
            <div className="main-content pc">
                {active === 'faq' && <FAQ faqList={supportData?.faqList || []} theme={theme} />}
                {hasForm && active === 'form' && <QuoteForm />}
                {active === 'tutorial' && <Tutorial videoList={supportData?.videoList || []} theme={theme} />}
                {active === 'manuals' && (
                    <Manuals
                        manualList={[...supportData?.onlineList, ...supportData?.downloadList?.filter((list: any) => list?.classify === 'MANUAL')]}
                        theme={theme}
                    />
                )}
            </div>
        </section>
    );
});
